import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from '@phosphor-icons/react';
interface StarterPromptsProps {
  onSelect: (prompt: string) => void;
}
const PROMPTS = ["What's Mateo's strongest case study?", 'How does he approach AI UX?', 'What measurable impact has he driven?', 'Match this to a role'];
/** Tappable suggestion chips shown in the empty / intro state. */
export function StarterPrompts({
  onSelect
}: StarterPromptsProps) {
  return <div className="mt-8 flex flex-col gap-2 w-full max-w-sm" data-id="element-469" data-mp="1wvowdwor8w97">
      {PROMPTS.map((prompt, i) => <motion.button key={prompt} type="button" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.35,
      delay: 0.15 + i * 0.07,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={() => onSelect(prompt)} className="group flex items-center justify-between gap-3 w-full text-left px-4 py-3 rounded-xl bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 hover:border-white/20 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30" data-id="element-470" data-mp="1rwvgxypwqv6e" data-mpi={i}>
          <span className="text-sm text-white/80 group-hover:text-white transition-colors" data-id="element-471" data-mp="15jr5wzh6fp9m">
            {prompt}
          </span>
          <ArrowUpRight className="w-4 h-4 text-white/30 group-hover:text-white/70 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 flex-shrink-0" weight="bold" aria-hidden="true" data-id="element-472" data-mp="1ai2g5bbdw1sd" />
        </motion.button>)}
    </div>;
}